import type { InferOutput } from "valibot";
import { type Options, useMutation } from "../useMutation";
import { type SendTransacInputSchema, SendTransacOutputSchema } from "./schemaTypes";

export const useSendTransacMutation = (options?: Options<InferOutput<SendTransacOutputSchema>>) => {
  return useMutation<SendTransacInputSchema, SendTransacOutputSchema>(
    "/api/send-transac/",
    SendTransacOutputSchema,
    options,
  );
};
